export default {"src":"/_next/static/media/icon-reward-shop.022df433.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};